import { Column, OneToMany } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MSfpSmartFilterEntity } from './m-sfp-smart-filter.entity';

@Entity('m_sfp_workd_component', {}, { label: 'Smart Filter Workd Component' })
export class MSfpWorkdComponentEntity extends BaseEntity {
	@Column('varchar', { name: 'alias', length: 255 })
	public alias!: string;

	@Column('varchar', { name: 'module', length: 64 })
	public module!: string;

	@Column('varchar', { name: 'url', nullable: true, length: 256 })
	public url!: string | null;

	@OneToMany(
		() => MSfpSmartFilterEntity,
		(mSfpSmartFilter) => mSfpSmartFilter.fkMSfpWorkdComponent,
		{},
	)
	public mSfpSmartFilters!: Array<MSfpSmartFilterEntity>;
}
